import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Heart } from "lucide-react";

// Tiny, low-profile horizontal logo strip surfacing the most recent live + past
// sponsors. ~80px tall. Only renders if there's at least 1 public sponsor.
export default function SponsorStrip() {
  const [sponsors, setSponsors] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/sponsors/wall").then(({ data }) => {
      if (!alive) return;
      // Live first, then most-recent past, capped at 8
      setSponsors([...(data.live || []), ...(data.past || [])].slice(0, 8));
    }).catch(() => { if (alive) setSponsors([]); });
    return () => { alive = false; };
  }, []);

  if (!sponsors || sponsors.length === 0) return null;

  return (
    <div className="border-t border-zinc-200 bg-white" data-testid="sponsor-strip">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-4 flex items-center gap-5 flex-wrap">
        <div className="flex items-center gap-2 text-[10px] font-mono uppercase tracking-widest text-zinc-500 flex-shrink-0">
          <Heart size={11} className="fill-red-600 text-red-600" />
          Brought to you by
        </div>
        <div className="flex items-center gap-4 flex-wrap flex-1 min-w-0">
          {sponsors.map((s) => (
            <a
              key={s.id}
              href={s.ad_link_url}
              target="_blank"
              rel="noreferrer sponsored nofollow"
              className="text-xs font-bold text-zinc-700 hover:text-red-600 transition-colors truncate max-w-[180px]"
              title={s.ad_title}
              data-testid={`sponsor-strip-${s.id}`}
            >
              {s.advertiser_name}
            </a>
          ))}
          <Link
            to="/sponsors"
            className="text-[10px] font-mono uppercase tracking-widest text-zinc-500 hover:text-red-600 ml-auto"
            data-testid="sponsor-strip-see-all"
          >
            See all →
          </Link>
        </div>
      </div>
    </div>
  );
}
